import { createSlice } from "@reduxjs/toolkit";
import { persistReducer } from "redux-persist";
import storage from "redux-persist/lib/storage";

const initialState = {
  isLoading: !false,
  isCreatingPaper: false,
  isFetchingPaper: true,
  createModal: false,
  papers: [],
  singlePaper: {},
  currentPaper: null,
  error: null,
  isEditingPaper: false,
  isDeletingPaper: false,
};

export const paperSlice = createSlice({
  name: "paper",
  initialState,
  reducers: {
    createPaperModal: (state, action) => {
      state.createModal = action.payload;
    },
    getPapersStart: (state, action) => {
      state.isLoading = true;
      state.error = null;
    },
    getPapersSuccess: (state, action) => {
      state.isLoading = false;
      state.papers = action.payload;
      state.error = null;
    },
    getPapersFailure: (state, action) => {
      state.isLoading = false;
      state.error = action.payload;
    },
    createPaperStart: (state, action) => {
      state.isCreatingPaper = true;
      state.error = null;
    },
    createPaperSuccess: (state, action) => {
      state.isCreatingPaper = false;
      state.error = null;
    },
    createPaperFailure: (state, action) => {
      state.isCreatingPaper = false;
      state.error = action.payload;
    },
    setCurrentPaper: (state, action) => {
      state.currentPaper = action.payload;
    },
    editPaperStart: (state, action) => {
      state.isEditingPaper = true;
    },
    editPaperSuccess: (state, action) => {
      state.isEditingPaper = false;
    },
    editPaperFailure: (state, action) => {
      state.isEditingPaper = false;
      state.error = action.payload;
    },
    deletePaperStart: (state, action) => {
      state.isDeletingPaper = true;
    },
    deletePaperSuccess: (state, action) => {
      state.isDeletingPaper = false;
    },
    deletePaperFailure: (state, action) => {
      state.isDeletingPaper = false;
      state.error = action.payload;
    },
    getSinglePaperStart: (state, action) => {
      state.isFetchingPaper = true;
    },
    getSinglePaperSuccess: (state, action) => {
      state.isFetchingPaper = false;
      state.singlePaper = action.payload;
    },
    getSinglePaperFailure: (state, action) => {
      state.isFetchingPaper = false;
      state.error = action.payload;
    },
    resetSinglePaperLoading: (state, action) => {
      state.isFetchingPaper = true;
    },
    createPaperCurriculumStart: (state, action) => {
      state.isCreatingPaper = true;
      state.error = null;
    },
    createPaperCurriculumSuccess: (state, action) => {
      state.isCreatingPaper = false;
      state.error = null;
    },
    createPaperCurriculumFailure: (state, action) => {
      state.isCreatingPaper = false;
      state.error = action.payload;
    },
    editPaperCurriculumStart: (state, action) => {
      state.isCreatingPaper = true;
      state.error = null;
    },
    editPaperCurriculumSuccess: (state, action) => {
      state.isCreatingPaper = false;
      state.error = null;
    },
    editPaperCurriculumFailure: (state, action) => {
      state.isCreatingPaper = false;
      state.error = action.payload;
    },
  },
});

export const {
  getPapersStart,
  getPapersSuccess,
  getPapersFailure,
  createPaperStart,
  createPaperSuccess,
  createPaperFailure,
  createPaperModal,
  setCurrentPaper,
  editPaperStart,
  editPaperSuccess,
  editPaperFailure,
  deletePaperStart,
  deletePaperSuccess,
  deletePaperFailure,
  getSinglePaperStart,
  getSinglePaperSuccess,
  getSinglePaperFailure,
  resetSinglePaperLoading,
  createPaperCurriculumStart,
  createPaperCurriculumSuccess,
  createPaperCurriculumFailure,
  editPaperCurriculumStart,
  editPaperCurriculumSuccess,
  editPaperCurriculumFailure,
} = paperSlice.actions;

const persistConfig = {
  key: "papers",
  storage,
  whitelist: ["currentPaper"],
};

const paperReducer = paperSlice.reducer;
export default persistReducer(persistConfig, paperReducer);
